export default __webpack_public_path__ + "images/2J.ce07ea8.png";